{
    "api_keys": {
        "max_active": "You can have at most {{max}} active keys. Revoke one to create a new key."
    },
    "vendor_cc_approver_needed": {
        "create_at_least_one": "Please create at least one vendor, cost center 1 and potential approver first."
    },
    "subscriptions": {
        "not_deletable_recurring": "Can't delete until all recurring expenses of this subscription have been deleted.",
        "date_started_info": "This date defines when finway creates the first recurring request. All subsequent recurring requests are based on this date."
    },
    "payment_subscription": {
        "need_to_be_cancelled_first": "Cancel subscription first."
    },
    "limit_add_disabled": "Limits can only be added if a possible approver (admin or approver in same team) can be determined.",
    "export_button_tabs": {
        "select_at_least_one": "Please select at least one request. Only data in table will be exported."
    },
    "discount_expired": "This discount has expired. Please delete it manually.",
    "expenses": {
        "credit_note_not_self_issued_receipt": "Self-issued receipts can't be credit notes.",
        "credit_note_purchase_order_linked": "Documents linked to a purchase order can't be credit notes.",
        "document_type_locked_after_review": "The document type can't be changed once the request is reviewed.",
        "not_editable_exported": "An exported expense can not be edited.",
        "purchase_order_link_credit_note": "Credit notes can't be linked to purchase orders.",
        "smartcards_payments_detected_automatically": "Expenses that use smart cards will detect payments automatically.",
        "not_all_information_provided": "Not all required information was provided.",
        "no_expense_selected": "No expense has been selected.",
        "vendor_not_approved": "Vendor is not approved.",
        "not_approved_yet": "Not all expenses are approved yet.",
        "edit_disabled_due_to_beleg": "Editing is not possible for this request as it is marked as GoBD-compliant. All fields are locked and cannot be modified.",
        "export_sepa_xml_disabled": "SEPA xml is disabled for card requests.",
        "export_non_sepa_xml_disabled": "NON-SEPA xml is disabled for card requests."
    },
    "reimbursement_types": {
        "standard": "Standard reimbursement",
        "standard_reimbursement": "Standard reimbursement",
        "mileage": "Mileage",
        "hospitality": "Hospitality",
        "per_diem": "Per diem"
    },
    "vendor": {
        "incompatible_creditor_number": "This creditor number is not compatible with DATEV.",
        "vendor_rule_inactive_due_to_settings": "This rule is inactive since the corresponding feature is disabled in the settings.",
        "was_deleted": "This vendor was deleted on {{date}}.",
        "name_short": "Official vendor name for DATEV compliance. Limited to 50 characters. This name is used for accounting and reporting purposes.",
        "name_extended_1": "Full vendor name for",
        "name_extended_2": "and payment processing. Allows longer names exceeding 50 characters to prevent warnings during payment checks.",
        "name_extended_link_label": "Verification-of-Payee (VoP)",
        "name_extended_link_url": "https://www.datev.de/web/de/nachrichten/gesetzliche-themen/payment-mit-datev/verification-of-payee/"
    },
    "read_direct_debit_agreement": "Please read the direct debit agreement.",
    "default_role_cannot_be_deleted": "This default role cannot be deleted.",
    "custom_bank_subject": "The bank subject line consists of the invoice number by default. However, you can add more information to the bank subject line, specify the order of the information, and still adjust it manually during the payment process.",
    "csv_template_settings": "You can create custom template(s) for the CSV export in the dashboard by removing, adding or changing the order of the columns in the export file.",
    "csv_transaction_import": {
        "change_sign": "Especially with Amex payments, the signs are often the opposite of the real data. Switch this toggle to adjust the sign of the transactions.",
        "csv_name": "Add a custom name to your CSV. Try for example “PayPal” or “Amex”. Note, that a CSV file will always be named “CSV” later on, so just use a short caption."
    },
    "expense_payment_flow_information": {
        "already_paid": "Payment info: already paid.",
        "already_approved_and_paid": "Payment info: already approved & paid.",
        "reporting_only": "Payment info: reporting only."
    },
    "vendorRulesShouldOverwrite": "By default, employee rules overwrite vendor rules. By enabling this setting, you can change that. If one value is not set in the rules checked first, e.g. cost center 1 is not filled in employee rules, it can be filled by vendor rules, if it is set there. ",
    "adjacent_request": {
        "previous": "Previous request in status ",
        "next": "Next request in status ",
        "purchase_approval_needed": "purchase approval pending",
        "invoice_approval_needed": "invoice approval pending",
        "approval_pending": "approval pending",
        "docs_needed": "documents needed",
        "in_review": "in review",
        "reviewed": "reviewed",
        "paid": "paid",
        "in_progress": "in progress",
        "done": "done",
        "all": "All"
    },
    "debit_card_limit_buffer": "Choose your default limit buffer (%) to prevent avoidable card transaction failures.",
    "datev": {
        "information_customisation": "View the default DUO information and booking text or customize it.",
        "subscription": "Expense type will be exported as \"Abonnement\"",
        "reimbursement_items": "Reimbursement type will be exported as e.g. \"Rückerstattung\", \"Kilometerpauschale\".\n Hospitality reimbursements will always export \"Bewirtung\" + name of attendees"
    },
    "hospitality": {
        "total_calculated_amount": "Total amounts calculate automatically based on the items"
    },
    "mileage": {
        "add_stop": "Additional stop will be added below this address.",
        "distance_buffer": "Set up a distance buffer in km that users can add manually to the calculated distance without being asked for a reason.",
        "distance": "Calculated automatically based on optimal route and rounded off to full kilometers",
        "total_calculated_amount": "Total amounts calculate automatically based on the items"
    },
    "per_diem": {
        "total_calculated_amount": "Total amounts calculate automatically based on the items"
    },
    "expense_reminder": "Follow-up set for {{date}}",
    "reports": {
        "refresh": "Refreshes data"
    },
    "approval_process": {
        "has_approved_request_on": "{{name}} has approved this request on {{date}}.",
        "has_rejected_request_on": "{{name}} has rejected this request on {{date}}.",
        "has_approved_request_on_for": "{{name}} has approved this request for {{approverName}} on {{date}}.",
        "has_rejected_request_on_for": "{{name}} has rejected this request for {{approverName}} on {{date}}.",
        "no_right": "You don't have the necessary rights to approve this request."
    },
    "fallback_approver": "Define the fallback approver to be used to unblock workflows in certain cases.",
    "recalculate_approval_processes_in_progress": "The approval processes that were created by this workflow will be recalculated. The approval process will be restarted and all current approvals will be lost.",
    "recalculate_approval_process_after_amount_changes": "If amounts in requests with approval processes in progress change, this setting will reset approvals and restart the current approval or select a more suitable workflow, if applicable.",
    "recalculate_approval_process_after_folder_amount_changes": "If amounts in folders with approval processes in progress change, this setting will reset approvals and restart the current approval or select a more suitable workflow, if applicable.",
    "recalculate_approval_process_after_other_changes": "If vendor, cost center 1 or 2 or requester in requests with approval processes in progress change, reset approvals and restart the current approval or select a more suitable workflow, if applicable.",
    "recalculate_approval_process_after_folder_other_changes": "If cost center 1 or 2 or requester in folders with approval processes in progress change, reset approvals and restart the current approval or select a more suitable workflow, if applicable.",
    "employee": {
        "was_deleted": "This user was deleted on {{date}}"
    },
    "vat": {
        "disabled_tax_rate_input": "This VAT % is used in request(s) and therefore, cannot be changed to avoid consolidated amount mismatches. Please create a new VAT %.",
        "was_deleted": "This tax rate was deleted on {{date}}.",
        "default_not_deletable": "The default VAT rate cannot be deleted."
    },
    "cost_center": {
        "was_deleted": "This cost center was deleted on {{date}}."
    },
    "cost_center_2": {
        "was_deleted": "This cost center 2 was deleted."
    },
    "expense_account": {
        "was_deleted": "This expense account was deleted."
    },
    "invoice_auto_matching_feature": "When enabled, invoices and requests with a match probability of 100% will be matched automatically.",
    "ocr_hint": "OCR must be activated to read invoices (incl. e-invoices).",
    "status": "Status",
    "sso": {
        "description": "Activate, deactivate or enforce Single Sign-On (SSO)",
        "enforce": "All users will be required to login with a SSO method starting on the next login. No data will be lost."
    },
    "mfa": {
        "enforce": "All users will be required to use a MFA method starting on the next login"
    },
    "folder": {
        "attach_empty": "Please select at least 1 request.",
        "sub_expense_status_left_behind": "Cannot approve folder due to one or more folder expense content's status is behind.",
        "single_sub_expense_status_left_behind": "This request's status is behind the folder's status.",
        "sub_expense_step_left_behind": "This request's approval step is below the folder's approval step.",
        "sub_expense_approval_left_behind": "This request require more approval to match the folder's.",
        "sub_expense_approval_missing_vendor": "Missing vendor.",
        "sub_expense_approval_missing_cost_center": "Missing cost center.",
        "unsubmitted_invoice": "This request has an unsubmitted invoice."
    },
    "shared_expense_tooltip": {
        "shared_multiple": "Shared by multiple users.",
        "shared": "Shared by"
    },
    "vendor_trigger_type_do_not_apply_to_mileage_and_per_diem": "Vendor trigger type does not apply to per diem and mileage reimbursement requests.",
    "approval_process_will_apply_to_recurring_expenses": "The master subscription will be auto-approved. This approval process will apply to recurring requests.",
    "synch_expenses": {
        "user": "Synch user updates to existing requests (does not apply to name and email).",
        "vendor": "Synch vendor updates to existing requests.",
        "vat": "Synch VAT / BU Code updates to existing requests.",
        "expense_account": "Synch expense account updates to existing requests."
    },
    "cards": {
        "bin_type_physical": "German BIN is not yet available for physical cards.",
        "bin_type_virtual": "Cards with a German BIN have a better acceptance rate, but they can currently only be used as virtual cards without Apple Pay and Google Pay."
    },
    "root_company_not_deletable": "Root company can't be deleted",
    "inbox_invoice": {
        "unassigned": "Unassigned",
        "assigned": "Assignee: {{name}}"
    },
    "personio": {
        "upload_csv": "Upload CSV",
        "include_user": "Include user",
        "contact_support_to_enable": "Please contact our support to enable the integration",
        "team_source": "This team has been fetched from Personio"
    },
    "datev_csv_config": {
        "wallet_account": "Please enter the finway wallet account here, e.g. a sub-account of 1200 (SKR 03) or 1800 (SKR 04).",
        "cash_transit_account": "Clearing account for charging the finway wallet, e.g. 1360 (SKR 03), 1460 (SKR 04) or available sub-accounts.",
        "account_number_length": "Please add the number length of the G/L accounts. Value must match the configuration of the mandate in DATEV.",
        "config_missing": "The DATEV Buchungsstapel configuration is not yet completed in the settings."
    },
    "datev_wallet_csv_statement_not_existing": "No file has been created yet. Regenerate the file using the three dots on the right.",
    "company_settings": {
        "vendor_payment_netting": "Vendor Payment Netting combines open invoices of a vendor into a single payment and offsets any available credit notes against them.",
        "employee_default_language": "This language will be set as default for new employees, but can be changed later in user settings.",
        "time_zone": "The time zone is decisive for all time-related data in finway. Please ask our support to adjust the time zone for this company.",
        "auto_matching_feature": "Auto Transaction Matching automatically matches expenses with their corresponding imported bank transactions. If an expense is auto-matched before review, it will skip the Payment stage immediately after review since it is already considered paid. If an expense is auto-matched while in the Payment stage, it will automatically move to the To Be Exported state, and if Auto Export is enabled it will be exported immediately and marked as Done."
    },
    "export_change_history": {
        "no_roles_access": "You need system administrator rights to choose this resource."
    },
    "setting_scope": {
        "company": "Only this company will be affected by this setting.",
        "global": "This setting is global. It applies to all your companies."
    },
    "employee_absence": {
        "substituted_by": "Due to absence replaced by: {{substitutedBy}}",
        "substituted_by_with_timeframe": "{{substitutedBy}} is substituting for {{approver}} from {{startDate}} until {{endDate}}.",
        "substituted_by_you_with_timeframe": "You are substituting for {{approver}} from {{startDate}} until {{endDate}}.",
        "approver_name_you": "you"
    },
    "ai_ocr_hint": "Our AI-powered OCR extracts text from your files quickly and accurately. Results may not be 100% perfect — please double-check important details.",
    "ocr_disabled_hint": "OCR is disabled because this delivery note contains linked items.",
    "delivery_note_fully_linked_hint": "All delivery note items are already linked.",
    "purchase_order": {
        "not_editable": {
            "approved": "Approved orders can't be edited to ensure accuracy in pricing and records."
        }
    },
    "workflow": {
        "net_amount": "Only the absolute amount is evaluated. Refunds (negative amounts) can still trigger this workflow."
    },
    "po_skip_procurement": "If enabled, the PO procurement process will be skipped and the order will be automatically released.",
    "action_disabled": "You can’t take this action because the feature has been disabled for your company. If you need access, please contact your administrator.",
    "changes_requested": "Changes requested",
    "vendor_payments": {
        "pending_credit_notes": "Credit notes {{expenseNumbers}} of this vendor are not approved yet. They need to be reviewed before they can be netted."
    }
}
